// Globally disable all console outputs to keep the app console clean
(function disableConsoleOutputs() {
  try {
    if (typeof window !== 'undefined') {
      const noop = function () {};
      const methods = [
        'log',
        'info',
        'warn',
        'error',
        'debug',
        'table',
        'trace',
        'group',
        'groupCollapsed',
        'groupEnd',
        'time',
        'timeEnd'
      ];
      methods.forEach((m) => {
        try { console[m] = noop; } catch (_) {}
      });
    }
  } catch (_) {}
})();
